import { render, staticRenderFns } from "./cooperative.vue?vue&type=template&id=1902c8df&scoped=true"
import script from "./cooperative.vue?vue&type=script&lang=js"
export * from "./cooperative.vue?vue&type=script&lang=js"
import style0 from "./cooperative.vue?vue&type=style&index=0&id=1902c8df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1902c8df",
  null
  
)

export default component.exports